import React from 'react'
import { useState } from 'react'
import Domain from "../../components/forms/domain"
import DashboardLayout from '../../components/layouts/dashboardLayout'
import AppApi from "../../api/app";
import UpdateProfile from '../../components/forms/updateProfile';
import { useSelector } from 'react-redux';
import UpdateSetting from '../../components/forms/updateSetting';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import { Breadcrumb } from 'react-bootstrap';

function ComingSoon() {
   return (
      <div className="container-fluid p-5 text-center">
         <h1>Coming Soon</h1>
         <p>This feature is currently under construction.</p>
      </div>
   )
}
function Settings() {
   let profile = useSelector(data => data.profile?.data);
   let [tab, setTab] = useState(1);
   return (
      <>
         <DashboardLayout>
            <div className="container-fluid mt-3">
               <div className="row">
                  <div className="col-12">
                     <Breadcrumb>
                        <Breadcrumb.Item href="#">
                           Dashboard
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>Global Settings</Breadcrumb.Item>
                     </Breadcrumb>
                  </div>
               </div>
               <div className="row gap-0">
                  <div className="col-12">
                     <Tab.Container id="left-tabs-example" defaultActiveKey="profile">
                        <div className='row gap-0 '>
                           <div className='col-md-2'>
                              <div className="bg-white rounded">
                                 <Nav variant="pills" className="flex-column settingTabs">
                                    <Nav.Item>
                                       <Nav.Link eventKey="profile" className="border-bottom">User Profile</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                       <Nav.Link eventKey="settings" className="border-bottom">Account Settings</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                       <Nav.Link eventKey="domain" className="border-bottom">Custom Domain</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                       <Nav.Link eventKey="socialMedia" className="border-bottom">Social Media Links</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                       <Nav.Link eventKey="seo" className="border-bottom">SEO Tools</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                       <Nav.Link eventKey="marketing" className="border-bottom">Marketing Tools</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                       <Nav.Link eventKey="branding" className="">Brand Customization</Nav.Link>
                                    </Nav.Item>
                                 </Nav>
                              </div>
                           </div>
                           <div className='col-md-10'>
                              <div className="bg-white rounded p-3">
                                 <Tab.Content>
                                    <Tab.Pane eventKey="profile">
                                       <UpdateProfile data={profile} />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="settings">
                                       <UpdateSetting data={profile} />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="socialMedia">
                                       <ComingSoon />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="domain">
                                       <Domain data={profile} />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="seo">
                                       <ComingSoon />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="marketing">
                                       <ComingSoon />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="branding">
                                       <ComingSoon />
                                    </Tab.Pane>
                                 </Tab.Content>
                              </div>
                           </div>
                        </div>
                     </Tab.Container>
                  </div>
               </div>
            </div>
         </DashboardLayout>

      </>
   )
}

export default Settings